// Organisation Info
export * from "./organisationInfo.component";
export * from "./organisationInfo.service";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/organisationInfo/index.ts